export default __webpack_public_path__ + "static/media/rewards-view.caffbbcc.png";